export default __webpack_public_path__ + "static/media/rap1.e1b87f5c.jpg";